/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProductInputs */

const en_nav_product = /** @type {(inputs: Nav_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const es_nav_product = /** @type {(inputs: Nav_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Nav_ProductInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_product = /** @type {((inputs?: Nav_ProductInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProductInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_product(inputs)
	return es_nav_product(inputs)
});